// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import {
    InitialBusDetailState,
    BusDetailSchema,
    BusDetailFormFields,
} from "./Configuration.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";
const BusDetail = ({ id, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [bus_detail, setBusDetail] = useState(InitialBusDetailState);

    const getBusDetail = async (id) => {
        spinService.on();
        const response = await get(EntityConstants.BUS_DETAILS + `/${id}`);
        const data = await response.json();
        setBusDetail(data);
        spinService.off();
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewBusDetail = values.id === undefined;
        const url = isNewBusDetail ? EntityConstants.BUS_DETAILS : EntityConstants.BUS_DETAILS + `/${values.id}`;
        const method = isNewBusDetail ? post : put;
        const response = await method(url, { bus_detail: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewBusDetail ? MessageContants.BUS_DETAIL_CREATED : MessageContants.BUS_DETAIL_UPDATED);
            onClose();
        }
        spinService.off();
    };

    useEffect(() => {
        if (id !== undefined) {
            getBusDetail(Number(id));
        }
    }, [id]);

    return (
        <Formik
            enableReinitialize
            initialValues={bus_detail}
            validationSchema={BusDetailSchema}
            onSubmit={(values) => handleSubmit(values)}
        >
            {({
                values,
                touched,
                errors,
                dirty,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
            }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <StyledDrawerForm>
                        <Grid
                            container
                            maxWidth="sm"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                        >
                            {BusDetailFormFields.map((formField, index) => {
                                return (
                                    <Grid key={index} item xs={12} sm={12} md={12} lg={12}>
                                        <GoForm
                                            config={formField}
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            handleChange={handleChange}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                        <Box sx={{ p: 2, textAlign: "right" }}>
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={<Iconify icon="eva:close-circle-outline" />}
                                onClick={() => onClose()}
                            >
                                Close
                            </Button>
                            &nbsp;&nbsp;
                            {((values.id === undefined && permissions.has(PermissionConstants.BUS_DETAIL_CREATE)) || (values.id !== undefined && permissions.has(PermissionConstants.BUS_DETAIL_UPDATE))) &&
                                <Button
                                    variant="contained"
                                    startIcon={<Iconify icon="eva:save-fill" />}
                                    type="submit"
                                >
                                    {values.id === undefined ? 'Save' : 'Update'}
                                </Button>
                            }
                        </Box>
                    </StyledDrawerForm>
                </Form>
            )}
        </Formik>
    );
};

BusDetail.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default BusDetail;
